import { ActivityStatus } from "@cca/components";
import { ActivityDto } from "@core/typesV2";
import { useEffect, useRef } from "react";

import { isActivityWithProgress } from "../utils";

export const useActivityAutoStart = ({
  currActivity,
  isActivitiesFetched,
  userIsLearner,
  previousActivitiesSubmitted,
  onStart,
}: {
  currActivity?: ActivityDto;
  isActivitiesFetched: boolean;
  userIsLearner: boolean;
  previousActivitiesSubmitted: boolean;
  onStart: (params: { activityId: string }) => void;
}) => {
  const prevActivityId = useRef<string | null>(null);

  useEffect(() => {
    if (
      !isActivitiesFetched ||
      !userIsLearner ||
      !currActivity ||
      !isActivityWithProgress(currActivity) ||
      (!previousActivitiesSubmitted && !currActivity.progress?.isReset) ||
      currActivity.progress?.status !== ActivityStatus.NotStarted
    ) {
      return;
    }

    if (prevActivityId.current === currActivity.activityId) {
      return;
    }

    prevActivityId.current = currActivity.activityId;
    onStart({ activityId: currActivity.activityId });
  }, [
    userIsLearner,
    currActivity,
    isActivitiesFetched,
    onStart,
    previousActivitiesSubmitted,
  ]);
};
